import { callApi } from "@src/api/callApi"
import { THEFT } from "@src/api/types"

export const deleteTheftsId = (id: number) =>
  callApi<null, THEFT>({
    method: "DELETE",
    path: `/thefts/${id}`,
  })
